// Mock data for the Haj App

// Campaign/Group Mock Data with Enhanced Structure
export const mockCampaigns = [
  {
    id: 1,
    campaignName: "Hajj Premium 2024",
    campaignType: "internal", // internal or sold
    date: "2024-03-15",
    departureDate: "2024-06-15",
    returnDate: "2024-06-30",
    memberCount: 25,
    maxCapacity: 30,
    totalRevenue: 125000,
    totalCosts: 95000,
    totalOutstandingDebt: 15000,
    netProfit: 15000,
    status: "active",
    notes: "Premium Hajj package with 5-star accommodation",
    createdAt: "2024-01-10",
    isDeleted: false,
    deletedAt: null,
    // For sold campaigns only
    costPrice: null,
    sellingPrice: null,
    buyerCompany: null,
    // Expenses breakdown
    expenses: {
      accommodationMadinah: 15000,
      accommodationMakkah: 20000,
      mealsMadinah: 8000,
      mealsMakkah: 10000,
      visaFees: 12500,
      airTickets: 25000,
      internalTransportation: 3000,
      programFees: 1500,
      miscellaneous: 0
    }
  },
  {
    id: 2,
    campaignName: "Umrah Economy Package",
    campaignType: "sold",
    date: "2024-02-01",
    departureDate: "2024-04-10",
    returnDate: "2024-04-17",
    memberCount: 40,
    maxCapacity: 40,
    totalRevenue: 80000,
    totalCosts: 60000,
    totalOutstandingDebt: 0,
    netProfit: 20000,
    status: "completed",
    notes: "Economy Umrah package sold to Al-Noor Travel",
    createdAt: "2024-01-05",
    isDeleted: false,
    deletedAt: null,
    // For sold campaigns
    costPrice: 60000,
    sellingPrice: 80000,
    buyerCompany: "Al-Noor Travel Agency",
    expenses: {
      accommodationMadinah: 8000,
      accommodationMakkah: 12000,
      mealsMadinah: 4000,
      mealsMakkah: 6000,
      visaFees: 10000,
      airTickets: 16000,
      internalTransportation: 2000,
      programFees: 1000,
      miscellaneous: 1000
    }
  },
  {
    id: 3,
    campaignName: "Family Hajj Special",
    campaignType: "internal",
    date: "2024-03-01",
    departureDate: "2024-07-01",
    returnDate: "2024-07-20",
    memberCount: 12,
    maxCapacity: 15,
    totalRevenue: 72000,
    totalCosts: 54000,
    totalOutstandingDebt: 24000,
    netProfit: -6000,
    status: "active",
    notes: "Special family package with customized services",
    createdAt: "2024-02-15",
    isDeleted: false,
    deletedAt: null,
    costPrice: null,
    sellingPrice: null,
    buyerCompany: null,
    expenses: {
      accommodationMadinah: 9000,
      accommodationMakkah: 15000,
      mealsMadinah: 4800,
      mealsMakkah: 7200,
      visaFees: 6000,
      airTickets: 10000,
      internalTransportation: 1500,
      programFees: 500,
      miscellaneous: 0
    }
  },
  {
    id: 4,
    campaignName: "VIP Umrah Experience",
    campaignType: "sold",
    date: "2024-01-20",
    departureDate: "2024-03-20",
    returnDate: "2024-03-27",
    memberCount: 8,
    maxCapacity: 10,
    totalRevenue: 48000,
    totalCosts: 32000,
    totalOutstandingDebt: 0,
    netProfit: 16000,
    status: "completed",
    notes: "VIP Umrah package sold to Luxury Pilgrimage Co.",
    createdAt: "2024-01-01",
    isDeleted: false,
    deletedAt: null,
    costPrice: 32000,
    sellingPrice: 48000,
    buyerCompany: "Luxury Pilgrimage Co.",
    expenses: {
      accommodationMadinah: 4000,
      accommodationMakkah: 8000,
      mealsMadinah: 2000,
      mealsMakkah: 3000,
      visaFees: 4000,
      airTickets: 8000,
      internalTransportation: 1500,
      programFees: 1000,
      miscellaneous: 500
    }
  }
];

// Legacy Groups for backward compatibility
export const mockGroups = mockCampaigns.map(campaign => ({
  id: campaign.id,
  groupName: campaign.campaignName,
  date: campaign.date,
  memberCount: campaign.memberCount,
  totalAmount: campaign.totalRevenue,
  status: campaign.status,
  notes: campaign.notes,
  createdAt: campaign.createdAt
}));

// Travelers Mock Data
export const mockTravelers = [
  {
    id: 1,
    campaignId: 1,
    fullName: "أحمد محمد علي",
    primaryPhone: "+966501234567",
    secondaryPhone: "+966507654321",
    passportNumber: "A12345678",
    totalAmountDue: 5000,
    paymentType: "installments", // cash or installments
    agentName: "وكالة الحرمين للسفر",
    agentCommission: 250,
    remainingBalance: 2000,
    status: "active",
    createdAt: "2024-01-10",
    isDeleted: false,
    deletedAt: null,
    // Payment plan details (for installments)
    paymentPlan: {
      downPayment: 1500,
      monthlyInstallment: 500,
      paymentDuration: 5, // months
      paidInstallments: 3,
      nextPaymentDate: "2024-04-15"
    }
  },
  {
    id: 2,
    campaignId: 1,
    fullName: "فاطمة عبدالله حسن",
    primaryPhone: "+966502345678",
    secondaryPhone: null,
    passportNumber: "B23456789",
    totalAmountDue: 5000,
    paymentType: "cash",
    agentName: "وكالة المدينة للحج والعمرة",
    agentCommission: 300,
    remainingBalance: 0,
    status: "paid",
    createdAt: "2024-01-12",
    isDeleted: false,
    deletedAt: null,
    paymentPlan: null
  },
  {
    id: 3,
    campaignId: 3,
    fullName: "محمد عبدالرحمن الأحمد",
    primaryPhone: "+966503456789",
    secondaryPhone: "+966508765432",
    passportNumber: "C34567890",
    totalAmountDue: 6000,
    paymentType: "installments",
    agentName: "مكتب الإيمان للسياحة",
    agentCommission: 400,
    remainingBalance: 4000,
    status: "active",
    createdAt: "2024-02-15",
    isDeleted: false,
    deletedAt: null,
    paymentPlan: {
      downPayment: 2000,
      monthlyInstallment: 800,
      paymentDuration: 5,
      paidInstallments: 0,
      nextPaymentDate: "2024-03-15"
    }
  },
  {
    id: 4,
    campaignId: 1,
    fullName: "عائشة سالم المطيري",
    primaryPhone: "+966504567890",
    secondaryPhone: null,
    passportNumber: "D45678901",
    totalAmountDue: 5000,
    paymentType: "installments",
    agentName: "وكالة الحرمين للسفر",
    agentCommission: 250,
    remainingBalance: 1500,
    status: "active",
    createdAt: "2024-01-15",
    isDeleted: false,
    deletedAt: null,
    paymentPlan: {
      downPayment: 1000,
      monthlyInstallment: 700,
      paymentDuration: 6,
      paidInstallments: 4,
      nextPaymentDate: "2024-04-20"
    }
  }
];

// Cash Box Transactions Mock Data
export const mockCashBoxTransactions = [
  {
    id: 1,
    transactionType: "Payment In", // Payment In, Expense Out
    paymentMethod: "Cash Down Payment",
    amount: 1500,
    fromTo: "أحمد محمد علي",
    relatedTo: "Down Payment - Hajj Premium 2024",
    notes: "دفعة مقدمة للحج",
    campaignId: 1,
    travelerId: 1,
    date: "2024-01-10",
    createdAt: "2024-01-10T10:00:00Z"
  },
  {
    id: 2,
    transactionType: "Payment In",
    paymentMethod: "Cash Full Payment",
    amount: 5000,
    fromTo: "فاطمة عبدالله حسن",
    relatedTo: "Full Payment - Hajj Premium 2024",
    notes: "دفع كامل نقدي",
    campaignId: 1,
    travelerId: 2,
    date: "2024-01-12",
    createdAt: "2024-01-12T14:30:00Z"
  },
  {
    id: 3,
    transactionType: "Expense Out",
    paymentMethod: "Bank Transfer",
    amount: 15000,
    fromTo: "فندق دار الإيمان",
    relatedTo: "Accommodation Madinah",
    notes: "دفع إقامة المدينة المنورة",
    campaignId: 1,
    travelerId: null,
    date: "2024-01-20",
    createdAt: "2024-01-20T09:15:00Z"
  },
  {
    id: 4,
    transactionType: "Payment In",
    paymentMethod: "Cash Installment",
    amount: 500,
    fromTo: "أحمد محمد علي",
    relatedTo: "Monthly Installment - Hajj Premium 2024",
    notes: "قسط شهري",
    campaignId: 1,
    travelerId: 1,
    date: "2024-02-15",
    createdAt: "2024-02-15T11:00:00Z"
  },
  {
    id: 5,
    transactionType: "Expense Out",
    paymentMethod: "Cash",
    amount: 250,
    fromTo: "وكالة الحرمين للسفر",
    relatedTo: "Agent Commission",
    notes: "عمولة الوكيل",
    campaignId: 1,
    travelerId: 1,
    date: "2024-01-25",
    createdAt: "2024-01-25T16:45:00Z"
  }
];

// Recycle Bin Mock Data
export const mockRecycleBin = [
  {
    id: 1,
    itemType: "campaign",
    itemId: 5,
    itemName: "Deleted Umrah Package 2024",
    originalData: {
      id: 5,
      campaignName: "Deleted Umrah Package 2024",
      campaignType: "internal",
      memberCount: 10,
      totalRevenue: 50000,
      status: "cancelled"
    },
    deletedBy: 1,
    deletedAt: "2024-01-20T14:30:00Z",
    reason: "Campaign cancelled by client"
  },
  {
    id: 2,
    itemType: "traveler",
    itemId: 5,
    itemName: "سارة أحمد المحمد",
    originalData: {
      id: 5,
      campaignId: 1,
      fullName: "سارة أحمد المحمد",
      primaryPhone: "+966505678901",
      passportNumber: "E56789012",
      totalAmountDue: 5000,
      paymentType: "cash"
    },
    deletedBy: 2,
    deletedAt: "2024-01-18T11:15:00Z",
    reason: "Traveler cancelled registration"
  },
  {
    id: 3,
    itemType: "user",
    itemId: 4,
    itemName: "موظف سابق",
    originalData: {
      id: 4,
      username: "former_staff",
      email: "former@hajapp.com",
      role: "dataentry",
      fullName: "موظف سابق",
      isActive: false
    },
    deletedBy: 1,
    deletedAt: "2024-01-15T16:00:00Z",
    reason: "Employee left the company"
  }
];

// Users Mock Data with Enhanced RBAC
export const mockUsers = [
  {
    id: 1,
    username: "admin",
    email: "admin@hajapp.com",
    role: "admin",
    fullName: "مدير النظام",
    isActive: true,
    lastLogin: "2024-01-15T10:30:00Z",
    createdAt: "2024-01-01T00:00:00Z",
    permissions: {
      campaigns: { view: true, create: true, edit: true, delete: true },
      travelers: { view: true, create: true, edit: true, delete: true },
      expenses: { view: true, create: true, edit: true, delete: true },
      payments: { view: true, create: true, edit: true, delete: true },
      reports: { view: true, create: true, edit: true, delete: true },
      users: { view: true, create: true, edit: true, delete: true },
      recycleBin: { view: true, restore: true, permanentDelete: true }
    },
    isDeleted: false,
    deletedAt: null
  },
  {
    id: 2,
    username: "dataentry",
    email: "dataentry@hajapp.com",
    role: "dataentry",
    fullName: "موظف إدخال البيانات",
    isActive: true,
    lastLogin: "2024-01-14T15:45:00Z",
    createdAt: "2024-01-02T00:00:00Z",
    permissions: {
      campaigns: { view: true, create: true, edit: true, delete: false },
      travelers: { view: true, create: true, edit: true, delete: false },
      expenses: { view: true, create: true, edit: true, delete: false },
      payments: { view: true, create: true, edit: false, delete: false },
      reports: { view: true, create: false, edit: false, delete: false },
      users: { view: false, create: false, edit: false, delete: false },
      recycleBin: { view: true, restore: false, permanentDelete: false }
    },
    isDeleted: false,
    deletedAt: null
  },
  {
    id: 3,
    username: "accountant",
    email: "accountant@hajapp.com",
    role: "accountant",
    fullName: "المحاسب المالي",
    isActive: true,
    lastLogin: "2024-01-13T09:20:00Z",
    createdAt: "2024-01-03T00:00:00Z",
    permissions: {
      campaigns: { view: true, create: false, edit: false, delete: false },
      travelers: { view: true, create: false, edit: false, delete: false },
      expenses: { view: true, create: true, edit: true, delete: true },
      payments: { view: true, create: true, edit: true, delete: true },
      reports: { view: true, create: true, edit: true, delete: false },
      users: { view: false, create: false, edit: false, delete: false },
      recycleBin: { view: true, restore: false, permanentDelete: false }
    },
    isDeleted: false,
    deletedAt: null
  }
];

// Products Mock Data
export const mockProducts = [
  {
    id: 1,
    programName: "Hajj Package Premium",
    seller: "Al-Noor Travel",
    price: 5000,
    availableCount: 25,
    description: "Premium Hajj package with 5-star accommodation",
    category: "hajj"
  },
  {
    id: 2,
    programName: "Umrah Package Standard",
    seller: "Makkah Tours",
    price: 2500,
    availableCount: 40,
    description: "Standard Umrah package with 3-star accommodation",
    category: "umrah"
  },
  {
    id: 3,
    programName: "Hajj Package Economy",
    seller: "Budget Hajj Co.",
    price: 3500,
    availableCount: 60,
    description: "Economy Hajj package with shared accommodation",
    category: "hajj"
  },
  {
    id: 4,
    programName: "Umrah Package VIP",
    seller: "Luxury Pilgrimage",
    price: 4000,
    availableCount: 15,
    description: "VIP Umrah package with luxury services",
    category: "umrah"
  }
];

// Transactions Mock Data
export const mockTransactions = [
  {
    id: 1,
    type: "income",
    amount: 1500,
    description: "Group A registration fees",
    date: "2024-01-15",
    agentName: "Ahmed Ali",
    paymentType: "Bank Transfer",
    groupId: 1
  },
  {
    id: 2,
    type: "expense",
    amount: 800,
    description: "Hotel booking for Group B",
    date: "2024-01-14",
    agentName: "Travel Agent",
    paymentType: "Cash",
    groupId: 2
  },
  {
    id: 3,
    type: "income",
    amount: 2200,
    description: "VIP Group C advance payment",
    date: "2024-01-13",
    agentName: "Aisha Abdullah",
    paymentType: "Check",
    groupId: 3
  },
  {
    id: 4,
    type: "expense",
    amount: 600,
    description: "Transportation costs",
    date: "2024-01-12",
    agentName: "Transport Co.",
    paymentType: "Bank Transfer",
    groupId: 1
  },
  {
    id: 5,
    type: "income",
    amount: 950,
    description: "Group B final payment",
    date: "2024-01-11",
    agentName: "Mohammed Omar",
    paymentType: "Cash",
    groupId: 2
  }
];

// Balances Mock Data
export const mockBalances = [
  {
    id: 1,
    agentOrUserName: "Ahmed Ali",
    totalDueAmount: 250,
    type: "user",
    lastPayment: "2024-01-15",
    status: "active"
  },
  {
    id: 2,
    agentOrUserName: "Al-Noor Travel Agency",
    totalDueAmount: -1200,
    type: "agent",
    lastPayment: "2024-01-14",
    status: "active"
  },
  {
    id: 3,
    agentOrUserName: "Fatima Hassan",
    totalDueAmount: 180,
    type: "user",
    lastPayment: "2024-01-13",
    status: "active"
  },
  {
    id: 4,
    agentOrUserName: "Makkah Tours",
    totalDueAmount: 800,
    type: "agent",
    lastPayment: "2024-01-12",
    status: "pending"
  },
  {
    id: 5,
    agentOrUserName: "Mohammed Omar",
    totalDueAmount: -50,
    type: "user",
    lastPayment: "2024-01-10",
    status: "overdue"
  }
];

// Payment Types
export const paymentTypes = [
  { value: 'cash', label: 'Cash' },
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'check', label: 'Check' },
  { value: 'credit_card', label: 'Credit Card' },
  { value: 'debit_card', label: 'Debit Card' }
];

// Group Status Options
export const groupStatuses = [
  { value: 'pending', label: 'Pending', color: 'warning' },
  { value: 'active', label: 'Active', color: 'success' },
  { value: 'completed', label: 'Completed', color: 'info' },
  { value: 'cancelled', label: 'Cancelled', color: 'error' }
];

// User Status Options
export const userStatuses = [
  { value: 'active', label: 'Active', color: 'success' },
  { value: 'inactive', label: 'Inactive', color: 'warning' },
  { value: 'suspended', label: 'Suspended', color: 'error' }
];

// Helper functions for mock data
export const getGroupById = (id) => {
  return mockGroups.find(group => group.id === parseInt(id));
};

export const getUserById = (id) => {
  return mockUsers.find(user => user.id === parseInt(id));
};

export const getProductById = (id) => {
  return mockProducts.find(product => product.id === parseInt(id));
};

export const getUsersByGroupId = (groupId) => {
  return mockUsers.filter(user => user.groupId === parseInt(groupId));
};

export const getTransactionsByDateRange = (startDate, endDate) => {
  return mockTransactions.filter(transaction => {
    const transactionDate = new Date(transaction.date);
    const start = new Date(startDate);
    const end = new Date(endDate);
    return transactionDate >= start && transactionDate <= end;
  });
};

export const getTransactionsByGroupId = (groupId) => {
  return mockTransactions.filter(transaction => transaction.groupId === parseInt(groupId));
};

// Generate random data helpers
export const generateRandomUser = () => {
  const names = ['Ali Ahmed', 'Sara Mohammed', 'Omar Hassan', 'Noor Abdullah', 'Yusuf Ibrahim'];
  const randomName = names[Math.floor(Math.random() * names.length)];
  
  return {
    id: Date.now() + Math.random(),
    userName: randomName,
    status: Math.random() > 0.3 ? 'active' : 'inactive',
    lastActivity: new Date().toISOString().slice(0, 16).replace('T', ' '),
    totalBalance: Math.floor(Math.random() * 500) - 100,
    email: `${randomName.toLowerCase().replace(' ', '.')}@email.com`,
    phone: `+96650${Math.floor(Math.random() * 10000000)}`
  };
};

export const generateRandomTransaction = (type = 'income') => {
  const descriptions = {
    income: ['Registration fees', 'Advance payment', 'Final payment', 'Service charges'],
    expense: ['Hotel booking', 'Transportation', 'Meals', 'Guide services']
  };
  
  return {
    id: Date.now() + Math.random(),
    type,
    amount: Math.floor(Math.random() * 2000) + 100,
    description: descriptions[type][Math.floor(Math.random() * descriptions[type].length)],
    date: new Date().toISOString().slice(0, 10),
    agentName: 'System Generated',
    paymentType: paymentTypes[Math.floor(Math.random() * paymentTypes.length)].label
  };
};